import authService from "../services/auth.service";

const user = JSON.parse(localStorage.getItem("userF"));
const initialState = user ? { loggedIn: true } : { loggedIn: false };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ commit, dispatch }, userData) {
      await authService.login(userData);
      commit("profile/RESET_PROFILE", null, { root: true });
      await dispatch("profile/getPermisos", null, { root: true });
      commit("logMeIn");
    },

    async logout({ commit }) {
      try {
        await authService.logout();
      } finally {
        commit("logMeOut");
        commit("profile/RESET_PROFILE", null, { root: true });
      }
    },

    async register({ commit }, userData) {
      await authService.register(userData);
      commit("logMeIn");
    },

    async recoverPassword(context, userData) {
      return await authService.recoverPassword(userData);
    },

    // USUARIOS
    async usuarios(context,usuario) {
      return await authService.usuarios(usuario);
    },

    async guardaUsuario(context, usuario) { 
      return await authService.guardaUsuario(usuario);
    },

    async borraUsuario(context, usuario) { 
      return await authService.borraUsuario(usuario);
    },

    async generarClaveUsuario(context, usuario) { 
      return await authService.generarClaveUsuario(usuario);
    },

    // CONFIGURACION
    async configuracion(context,configuracion) {
      return await authService.configuracion(configuracion);
    },

    async guardaConfiguracion(context, configuracion) { 
      return await authService.guardaConfiguracion(configuracion);
    },

    // AUTH
    async autocompletaEmpresa(context,configuracion) {
      return await authService.autocompletaEmpresa(configuracion);
    },

    async autocompletaFarmacia(context,configuracion) {
      return await authService.autocompletaFarmacia(configuracion);
    },

    async seleccionaFarmacia(context,configuracion) {
      return await authService.seleccionaFarmacia(configuracion);
    },
  },
  mutations: {
    logMeIn(state) {
      state.loggedIn = true;
    },
    logMeOut(state) {
      state.loggedIn = false;
    },
  },

  getters: {
    loggedIn(state) {
      return state.loggedIn;
    },
  },
};
